import { render, staticRenderFns } from "./InstanceEditMail.vue?vue&type=template&id=2e489a50&scoped=true&"
import script from "./InstanceEditMail.vue?vue&type=script&lang=js&"
export * from "./InstanceEditMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e489a50",
  null
  
)

export default component.exports